import { render } from "./TaskBoxLeftLineB.vue?vue&type=template&id=a955076c&scoped=true"
import script from "./TaskBoxLeftLineB.vue?vue&type=script&lang=js"
export * from "./TaskBoxLeftLineB.vue?vue&type=script&lang=js"

import "./TaskBoxLeftLineB.vue?vue&type=style&index=0&id=a955076c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a955076c"]])

export default __exports__